import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';
import styles from './Modal.styl';

@observer
export class Modal extends React.Component<{ onClose: () => void }> {
    @observable isOpen = true;
    @action close = () => this.isOpen = false;

    private interceptEvents = (node): void => {
        if (!node) {
            return;
        }

        node.addEventListener('wheel', event => event.preventDefault());
        node.addEventListener('touchmove', event => event.preventDefault());
    };

    render() {
        const { children, onClose } = this.props;
        return (
            <ReactModal
                isOpen={this.isOpen}
                shouldFocusAfterRender

                shouldCloseOnOverlayClick
                shouldCloseOnEsc
                onRequestClose={this.close}
                onAfterClose={onClose}
                closeTimeoutMS={500}

                overlayRef={this.interceptEvents}

                overlayClassName={styles.overlay}
                className={styles.body}
            >
                <button onClick={this.close} className={styles.closeButton}></button>
                {children}
            </ReactModal>
        );
    }
}
